import { ChevronRight } from 'react-feather'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faComment } from '@fortawesome/free-solid-svg-icons'
import { FormattedMessage } from 'react-intl'

export default [
    {
        id: 'newsAndActivity',
        title: <FormattedMessage id='Information' />,
        icon: <FontAwesomeIcon icon={faComment} />,
        navLink: '/',

        children: [
            {
                id: 'news',
                title: <FormattedMessage id='News' />,
                icon: <ChevronRight />,
                navLink: '/news'
            },
            {
                id: 'articles',
                title: <FormattedMessage id='Articles' />,
                icon: <ChevronRight />,
                navLink: '/articles'
            },
            {
                id: 'job',
                title: <FormattedMessage id='Job' />,
                icon: <ChevronRight />,
                navLink: '/job'
            },
            {
                id: 'certificate',
                title: <FormattedMessage id='Certificate' />,
                icon: <ChevronRight />,
                navLink: '/certificate'
            },
            {
                id: 'magazine',
                title: <FormattedMessage id='Magazine' />,
                icon: <ChevronRight />,
                navLink: '/magazine'
            }

        ]
    }
]